import {
  getCourseView,
  getCourseAssignments,
  getCourseInfo,
} from '../core/lms';
import { VIEW_RELATION_TYPES } from '../util/constants';
import {
  GET_COURSE_REQUEST,
  GET_COURSE_SUCCESS,
  GET_COURSE_FAILURE,
} from './constants';

export const getCourse = (id) => async (dispatch) => {
  dispatch({ type: GET_COURSE_REQUEST });

  try {
    const [course, assignments, readingView] = await Promise.all([
      getCourseInfo(id),
      getCourseAssignments(id),
      getCourseView(id, VIEW_RELATION_TYPES.READING_VIEW_ID),
    ]);

    if (!course?.id) {
      throw new Error('Invalid course data received');
    }

    const courseData = {
      ...course,
      assignments: assignments ?? [],
      assignment_views_relation: readingView?.assignment_views_relation ?? [],
    };

    dispatch({
      type: GET_COURSE_SUCCESS,
      payload: {
        course: courseData,
        id: course.id,
      },
    });
  } catch (error) {
    const errorMessage = error.message || 'Failed to fetch course data';

    dispatch({
      type: GET_COURSE_FAILURE,
      payload: {
        error: errorMessage,
        status: error.status,
      },
    });

    if (error.status === 403) {
      console.error('Access denied for course:', id);
    } else if (error.status === 404) {
      console.error('Course not found:', id);
    } else {
      console.error('Error fetching course:', errorMessage);
    }

    throw error;
  }
};
